import React from 'react';
import './footer.scss';

function Footer({tagline}) {
    return (
        <footer className="acuwize-footer">
            <span className="acuwize-footer__brand">Acuwize</span>
            {tagline && <span className="acuwize-footer__tagline">{tagline}</span>}
            <span className="acuwize-footer__copy">© {new Date().getFullYear()} Acuwize.</span>
        </footer>
    );
}

export default Footer;
